import * as React from 'react'

const SvgCryptoCurrency = () => (
  <svg
    width="48"
    height="156"
    viewBox="0 0 48 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 0V104"
      stroke="url(#paint0_linear_229_2507)"
      stroke-dasharray="3 3"
    />
    <rect
      y="108"
      width="48"
      height="48"
      rx="24"
      fill="url(#paint1_linear_229_2507)"
    />
    <path
      d="M14 122L16 124M34 122L32 124M34 142L32 140M14 142L16 140M14 136H15.5M20 122V123.5M34 128H32.5M28 142V140.5M30 136H33.5M28 122V126M14 128H18M20 142V138M23.4343 127.566L19.5657 131.434C19.3677 131.632 19.2687 131.731 19.2316 131.845C19.1989 131.946 19.1989 132.054 19.2316 132.155C19.2687 132.269 19.3677 132.368 19.5657 132.566L23.4343 136.434C23.6323 136.632 23.7313 136.731 23.8455 136.768C23.9459 136.801 24.0541 136.801 24.1545 136.768C24.2687 136.731 24.3677 136.632 24.5657 136.434L28.4343 132.566C28.6323 132.368 28.7313 132.269 28.7684 132.155C28.8011 132.054 28.8011 131.946 28.7684 131.845C28.7313 131.731 28.6323 131.632 28.4343 131.434L24.5657 127.566C24.3677 127.368 24.2687 127.269 24.1545 127.232C24.0541 127.199 23.9459 127.199 23.8455 127.232C23.7313 127.269 23.6323 127.368 23.4343 127.566Z"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_229_2507"
        x1="24.5"
        y1="0"
        x2="24.5"
        y2="104"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="#155EEF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_229_2507"
        x1="24"
        y1="108"
        x2="24"
        y2="156"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#155EEF" />
        <stop offset="1" stop-color="#15A6EF" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgCryptoCurrency
